<template>
  <router-view />
</template>

<style lang="scss">
@use '@/assets/scss/index.scss' as *;

* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box; //怪异模式
}

body {
  overflow: hidden;
  margin: 0px;
  background-color: #000;
  height: 100vh;
  width: 100vw;
  color: $text-color;

  #app {
    height: 100%;
    width: 100%;
  }

  /*滚动条整体*/
  ::-webkit-scrollbar {
    width: 8px;
  }

  /*滑轨*/
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  /*滑块*/
  ::-webkit-scrollbar-thumb {
    background-color: $main-color;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
